require('./accountIntervenerRemoveView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ actions
const accountIntervenersRemoveActions = require('actions/accountIntervenersRemove');
const accountIntervenersActions = require('actions/getAccountInterveners');
// @ components
const AccountDetailsSideBar = require('components/accounts/accountDetailsSidebar/accountDetailsSidebar');
const AccountMoreOptionsButton = require('components/accounts/accountMoreOptionsButton/accountMoreOptionsButton');
const AccountIntervenerRemoveForm = require('components/accounts/accountIntervenerRemove/accountIntervenerRemoveForm/accountIntervenerRemoveForm');
const AccountIntervenerRemoveSuccess = require('components/accounts/accountIntervenerRemove/accountIntervenerRemoveSuccess/accountIntervenerRemoveSuccess');
const AccountIntervenerRemoveError = require('components/accounts/accountIntervenerRemove/accountIntervenerRemoveError/accountIntervenerRemoveError');
//@utilities
const AccessHelper = require('utilities/accessHelper');
//@constants
const { accountConstants } = require('utilities/accessHelperConditions/accounts');

class AccountIntervenerRemoveView extends React.Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { history, match: { params: { accountId } }, requestInterveners, immAccounts } = this.props;

        AccessHelper.allowAccess(accountConstants.ACCOUNTS_INTERVENER_REMOVE, { immAccounts, accountId }, history);
        requestInterveners(accountId);
    }

    componentWillUnmount() {
        this.props.clearIntervenerRemoval();
    }

    render() {
        const { match: { params: { accountId, intervenerIndex } }, immAccounts, immAccountIntervenerRemoval, removeIntervener, clearIntervenerRemoval } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        let block;

        if (immAccount) {
            const subtitleLeft = immAccount.get('alias');
            const subtitleRight = getLastNChars(immAccount.get('iban'));
            const immInterveners = immAccount.get('interveners').get('list');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-accounts'),
                    url: '/myprofile/accounts'
                },
                {
                    text: immAccount.get('alias'),
                    url: `/myprofile/accounts/${accountId}/movements`
                },
                {
                    text: formatText('breadcrumb-accountInformation'),
                    url: `/myprofile/accounts/${accountId}/details`
                },
                {
                    text: formatText('breadcrumb-removeIntervener')
                }
            ];
            let bodyContent;

            if (immInterveners.size > 0) {
                const immIntervener = immInterveners.get(intervenerIndex);

                if (immAccountIntervenerRemoval.get('success')) {
                    bodyContent = (
                        <div className="row no-gutter">
                            <div className="col-xs-offset-2 col-xs-8">
                                <AccountIntervenerRemoveSuccess
                                    immAccount={immAccount}
                                    immIntervener={immIntervener}
                                    clearIntervenerRemoval={clearIntervenerRemoval}
                                />
                            </div>
                        </div>
                    );
                } else if (immAccountIntervenerRemoval.get('error')) {
                    bodyContent = (
                        <div className="row no-gutter">
                            <div className="col-xs-offset-2 col-xs-8">
                                <AccountIntervenerRemoveError
                                    immAccount={immAccount}
                                    immIntervener={immIntervener}
                                    immAccountIntervenerRemoval={immAccountIntervenerRemoval}
                                    clearIntervenerRemoval={clearIntervenerRemoval}
                                />
                            </div>
                        </div>
                    );
                } else {
                    bodyContent = (
                        <div className="row no-outside-gutter">
                            <div className="col-xs-8 left-column">
                                <AccountIntervenerRemoveForm
                                    immAccount={immAccount}
                                    immAccountIntervenerRemoval={immAccountIntervenerRemoval}
                                    immIntervener={immIntervener}
                                    intervenerIndex={intervenerIndex}
                                    removeIntervener={removeIntervener}
                                />
                            </div>
                            <div className="col-xs-4 right-column">
                                <AccountDetailsSideBar immAccount={immAccount} />
                            </div>
                        </div>
                    );
                }
            } else {
                bodyContent = <LoadingSection />;
            }

            block = (
                <article className="account-intervener-remove-view" id="printable-wizard">
                    <OKCover size="medium" section="accounts">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            subtitleLeft={subtitleLeft}
                            subtitleRight={subtitleRight}
                            finalTitle={getFinalTitle('breadcrumb-removeIntervener')}
                        >
                            <AccountMoreOptionsButton accountId={accountId} />
                        </OKHeaderSubPage>
                    </OKCover>
                    <section className="account-intervener-remove-view__body">
                        {bodyContent}
                    </section>
                </article>
            );
        } else {
            block = <LoadingSection />;
        }

        return block;
    }
}

AccountIntervenerRemoveView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountIntervenerRemoval: PropTypes.object.isRequired,
    removeIntervener: PropTypes.func.isRequired,
    clearIntervenerRemoval: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired
};

module.exports.constructor = AccountIntervenerRemoveView;
module.exports.AccountIntervenerRemoveView = connect(
    state => ({
        immAccounts: state.accounts,
        immAccountIntervenerRemoval: state.accountIntervenerRemoval
    }), {
    removeIntervener: accountIntervenersRemoveActions.removeIntervener,
    clearIntervenerRemoval: accountIntervenersRemoveActions.clearIntervenerRemoval,
    requestInterveners: accountIntervenersActions.requestAccountInterveners
})(withRouter(AccountIntervenerRemoveView));
